import {
  LOAD_MODEL,
  UPDATE_FILTER,
  RESET,
  TEMPLATE,
  CATEGORY,
  SECOND,
  UPDATE_STATS,
  ADD_FOLDER,
  ADD_TEMPLATE,
  DELETE_FOLDER,
  DELETE_TEMPLATE,
  RENAME_FOLDER,
  EDIT_TEMPLATE,
  GET_FOLDERS_COLLECTIONS,
  SAVE_COLLECTION,
  SAVE_COLLECTIONS,
  EDIT_COLLECTIONS,
  DELETE_COLLECTIONS,
  CREATE_COLLECTIONS_FOLDER,
  RENAME_COLLECTIONS_FOLDER,
  DELETE_COLLECTIONS_FOLDER,
  ADD_ACTIVE_FOLDER,
  SET_MODE_COMPARE,
  CHANGE_COLLECTION_CHECKBOX,
  SET_QUICK_INFO_COMPARE,
  CLEAR_SETTING_VIEWER,
  UPDATE_TEMPLATE_SETTINGS,
  SET_COLOR_PRIMARY_COLUMN,
  CREATE_SETTING_FILTER_SCHEME,
  SET_CUSTOM_PROPERTIES,
  EDIT_CUSTOM_PROPERTIES,
  DELETE_CUSTOM_PROPERTIES,
  LOAD_CUSTOM_PROPERTIES,
  GET_PARAMETERS_OF_SELECTED_ELEMENTS,
  CLEAR_PARAMETERS_OF_SELECTED_ELEMENTS_FROM_STATE,
  SAVE_SELECTION_OF_VIEWER,
} from "../constans";
import { resizeViewer, unColorCollection } from "utils/builder/IScheduleLogic";
import { selectCollectionOnView, unselectCollectionOnView } from "../actions/collections";

const select = {
  categories: null,
  filterValues: null,
  groups: null,
  properties: null,
  secondFilter: null,
};

export const ItemsTypeEnum = Object.freeze({
  colors: 'colors',
  filters: 'filters'
})

export const initTemporarySetting = {
  metaData: {
    id: null,
    name: null,
    isSidebarOpen: false,
    isPrimaryColor: false,
    isHiddenColumn: false,
  },
  type: null,
  settingsItems: {},
  existingValue: null,
};

export const initTemplateSettings = {
  categories: null,
  groups: null,
  tableColumns: [],
  filterValues: null,
  secondFilter: null,
  temporarySetting: initTemporarySetting,
  filtersSchemes: {},
};

const initState = {
  categories: null,
  filterByOptions: null,
  filterValues: null,
  groupingOptions: [],
  properties: null,
  templateSettings: initTemplateSettings,
  templates: null,
  template: null,
  quickInfoCompare: null,
  compare: {
    isModeCompare: false,
    collections: {},
    selectionDetails: []
  },
  customProperties: [],
  customPropertiesValues: [],
  customPropertiesInstances: null,
  parametersOfSelection: {},
  adskViewerSelection: {}
};

const viewerReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case LOAD_MODEL: {

      const commonCategories = payload?.commonCategories;
      const uncommonCategories = payload?.uncommonCategories;
      const commonProperties = payload?.commonProperties;
      const uncommonProperties = payload?.uncommonProperties;
      const commonGroupingOptions = payload?.commonGroupingOptions;
      const uncommonGroupingOptions = payload?.uncommonGroupingOptions;
    
      const prevTS = state.templateSettings || initTemplateSettings;
      const incomingTS = payload?.templateSettings || null;
    
      const nextTemplateSettings = {
        ...prevTS,
        ...(incomingTS || {}),
        tableColumns: incomingTS?.tableColumns ?? prevTS.tableColumns,
        filtersSchemes: incomingTS?.filtersSchemes ?? prevTS.filtersSchemes,
      };
    
      return {
        ...state,
        ...payload,
        commonCategories,
        uncommonCategories,
        commonProperties,
        uncommonProperties,
        commonGroupingOptions,
        uncommonGroupingOptions,
        templateSettings: nextTemplateSettings,
      };
    }

    case SET_CUSTOM_PROPERTIES:
      const payloadName = payload.map(item => item?.name);
      const payloadValue = payload?.filter(payloadItem => ({ name: payloadItem?.name, values: payloadItem?.values, type: payloadItem?.type }));

      return {
        ...state,
        ...payload,
        customProperties: payloadName,
        customPropertiesValues: payloadValue,
      };

    case LOAD_CUSTOM_PROPERTIES: {
      const names = Array.isArray(payload) ? payload.map(i => i?.name) : [];
      const values = Array.isArray(payload) ? payload.map(i => ({ name: i?.name, values: i?.values, type: i?.type })) : [];
      const customPropertiesInstances = payload
      
      // Update tableColumns with correct types from server
      const updatedTableColumns = state?.templateSettings?.tableColumns?.map(column => {
        const columnName = column.metaData?.name;
        if (columnName && names.includes(columnName)) {
          const customParam = Array.isArray(payload) ? payload.find(p => p?.name === columnName) : null;
          if (customParam && customParam.type !== undefined && customParam.type !== null) {
            return {
              ...column,
              type: customParam.type
            };
          }
        }
        return column;
      }) || state?.templateSettings?.tableColumns;
      
      return {
        ...state,
        customProperties: names,
        customPropertiesValues: values,
        customPropertiesInstances,
        templateSettings: {
          ...state.templateSettings,
          tableColumns: updatedTableColumns
        }
      };
    }
    case EDIT_CUSTOM_PROPERTIES:
    const customPropertiesName = payload?.res?.map(item => item?.name);

    const customPropertiesValue = payload?.res?.map(payloadItem => ({ name: payloadItem?.name, values: payloadItem?.values, type: payloadItem?.type }));
    const updatedTemplateSettingsEditProperties = state?.templateSettings?.tableColumns?.map(item => {
  if (item?.metaData?.name === payload?.oldName) {
    const newType = payload?.selectedType !== undefined ? payload.selectedType : item.type;
    return {
      ...item,
      type: newType,
      metaData: {
        ...item.metaData,
        name: payload?.name
      }
    }
  } else {
    return item
  }
});

return {
  ...state,
  ...payload,
  customProperties: customPropertiesName,
  customPropertiesValues: customPropertiesValue,
  templateSettings: {
    ...state.templateSettings,
    tableColumns: updatedTemplateSettingsEditProperties
  }
};
      case DELETE_CUSTOM_PROPERTIES: {
        const names = Array.isArray(payload?.res) ? payload.res.map(i => i?.name) : [];
        const values = Array.isArray(payload?.res) ? payload.res.map(i => ({ name: i?.name, values: i?.values, type: i?.type })) : [];
        const updatedTableColumns = state?.templateSettings?.tableColumns?.filter(
          col => col?.metaData?.name !== payload?.name
        );
      
        return {
          ...state,
          customProperties: names,
          customPropertiesValues: values,
          templateSettings: {
            ...state.templateSettings,
            tableColumns: updatedTableColumns,
          },
        };
      }

    case RESET:
      return {
        ...initState,
        categories: state.categories,
        templates: state.templates,
        collectionsFolders: state.collectionsFolders,
        template: payload,
        templatesCount: state.templatesCount,
        commonCategories: state.commonCategories,
        uncommonCategories: state.uncommonCategories,
        templatesFolder: state.templatesFolder
      };

      case UPDATE_FILTER: {
        resizeViewer();
        const { settings, ...rest } = payload || {};
        const prev = state.templateSettings || {};
        const nextSettings = {
          ...prev,
          ...settings,
          tableColumns: (settings && settings.tableColumns) ? settings.tableColumns : prev.tableColumns,
          filtersSchemes: (settings && settings.filtersSchemes) ? settings.filtersSchemes : prev.filtersSchemes,
        };
        return {
          ...state,
          ...rest,
          templateSettings: nextSettings,
        };
      }
    case TEMPLATE:
      return {
        ...state,
        ...payload,
      };
    case CATEGORY: {
      resizeViewer();

      const newState = {
        ...state,
        ...payload,
        // commonProperties: state.commonProperties,
        template: null,
      };

      return newState;
    }
    case SECOND:
      return {
        ...state,
        ...payload,
        selection: {
          ...payload.selection,
          categories: state.selection.categories,
          secondFilter: state.selection.secondFilter,
          filterValues: state.selection.filterValues,
        },
      };
    case UPDATE_STATS:
      var newState = { ...state };
      newState.quickCounterData = payload;
      return {
        ...state,
        ...newState,
      };
    case SET_QUICK_INFO_COMPARE:
      return {
        ...state,
        quickInfoCompare: payload,
      };
    case ADD_FOLDER:
      return {
        ...state,
        templatesFolder: {
          ...state.templatesFolder,
          [payload]: []
        }
      };
    case RENAME_FOLDER:
      const copyArray = state.templatesFolder[payload.originalName];
      const templatesFolder = state.templatesFolder;

      delete templatesFolder[payload.originalName];

      return {
        ...state,
        templatesFolder: {
          ...templatesFolder,
          [payload.newNameFolder]: copyArray
        }
      };
    case ADD_TEMPLATE:
      const newArray = [...state.templatesFolder[payload.folder], payload.template].sort();

      return {
        ...state,
        templatesFolder: {
          ...state.templatesFolder,
          [payload.folder]: newArray
        }
      };
    case EDIT_TEMPLATE:
      const arrayWithoutOldTemplates = state.templatesFolder[payload.currentNameFolder].filter((el) => el !== payload.currentNameTemplate);

      if (payload.newNameFolder === payload.currentNameFolder) {

        const arrayWithNewTemplate = [...arrayWithoutOldTemplates, payload.newNameTemplate].sort();

        return {
          ...state,
          templatesFolder: {
            ...state.templatesFolder,
            [payload.currentNameFolder]: arrayWithNewTemplate,
          }
        };
      } else {

        const arrayWithNewTemplate = [...state.templatesFolder[payload.newNameFolder], payload.newNameTemplate].sort();

        return {
          ...state,
          templatesFolder: {
            ...state.templatesFolder,
            [payload.currentNameFolder]: arrayWithoutOldTemplates,
            [payload.newNameFolder]: arrayWithNewTemplate
          }
        };
      }
    case DELETE_FOLDER:
      const templatesFolderNew = state.templatesFolder;

      delete templatesFolderNew[payload];

      return {
        ...state,
      };
    case DELETE_TEMPLATE:
      const templatesNew = state.templatesFolder[payload.folderName].filter((el) => el !== payload.templateName);

      return {
        ...state,
        templatesFolder: {
          ...state.templatesFolder,
          [payload.folderName]: templatesNew
        }
      };
    case GET_FOLDERS_COLLECTIONS:
      return {
        ...state,
        collectionsFolders: payload
      };
    case SAVE_COLLECTIONS:
      return {
        ...state,
        collections: payload
      };
    case SAVE_COLLECTION:
      return {
        ...state,
        collections: payload
      };
    case CREATE_COLLECTIONS_FOLDER:
      return {
        ...state,
        collectionsFolders: [...state.collectionsFolders, payload].sort()
      };
    case RENAME_COLLECTIONS_FOLDER:
      const copyArrayCollection = state.collectionsFolders.filter((folder) => folder !== payload.originalNameFolder);

      return {
        ...state,
        collectionsFolders: [...copyArrayCollection, payload.newNameFolder]
      }
    case DELETE_COLLECTIONS_FOLDER:
      const newCollection = state.collectionsFolders.filter((folder) => folder !== payload);

      return {
        ...state,
        collectionsFolders: newCollection
      }
    case EDIT_COLLECTIONS:
      let newEditCollection = state.collections;

      if (payload.oldFolder !== payload.newFolder) {
        newEditCollection = state.collections.filter((collection) => collection.name !== payload.oldTitle);
      }

      return {
        ...state,
        collections: newEditCollection
      };
    case DELETE_COLLECTIONS:
      const newDeleteCollection = state.collections.filter((collection) => collection.creationTime !== payload.id);

      return {
        ...state,
        collections: newDeleteCollection
      };
    case ADD_ACTIVE_FOLDER:
      return {
        ...state,
        activeFolder: payload
      };
    case SET_MODE_COMPARE:
      if (payload) {
        return {
          ...state,
          compare: { ...state.compare, isModeCompare: payload }
        };
      } else {

        const uncheckedCollections = state.collections.map((collection) => {
          return { ...collection, checked: false }
        });

        return {
          ...state,
          compare: { ...state.compare, isModeCompare: payload, selectionDetails: [], collections: {} },
          collections: uncheckedCollections
        };
      }

    case CHANGE_COLLECTION_CHECKBOX:
      const newCollectionsCompare = {
        ...state.compare.collections,
        [payload.activeFolder]: payload.collections.map((collection) => {
          if (collection.creationTime === payload.collection.creationTime) {
            return { ...collection, checked: !collection?.checked }
          } else {
            return collection
          }
        })
      }

      const newCollections = state.collections.map((collection) => {

        let checked = false;

        newCollectionsCompare[payload.activeFolder].map((collectionCompare) => {
          if (collection.creationTime === collectionCompare.creationTime) {
            checked = collectionCompare.checked;
          }
        })

        return { ...collection, checked }
      })

      const isCollectionDetails = state.compare.selectionDetails.some((el) => el.id === payload.selectionDetails.id);
      let newSelectionDetails = state.compare.selectionDetails;

      if (isCollectionDetails) {
        newSelectionDetails = state.compare.selectionDetails.filter((el) => el.id !== payload.selectionDetails.id);
      } else {
        newSelectionDetails.push(payload.selectionDetails);
      }

      const selectElements = Object.values(newCollectionsCompare).flat(2).filter((el) => el.checked);
      selectCollectionOnView(selectElements);

      return {
        ...state,
        compare: { ...state.compare, collections: newCollectionsCompare, selectionDetails: newSelectionDetails },
        collections: newCollections,
      };
    case CLEAR_SETTING_VIEWER:
      return initState
      case UPDATE_TEMPLATE_SETTINGS: {
        const updateData = payload?.updateData || {};
        const prev = state.templateSettings || {};
        
        // Get current custom properties types as source of truth for custom columns
        const customPropertiesTypes = {};
        state.customPropertiesValues?.forEach(cp => {
          if (cp.name && cp.type !== undefined) {
            customPropertiesTypes[cp.name] = cp.type;
          }
        });
        
        // If updateData has tableColumns, preserve types from customPropertiesValues for custom columns
        let finalTableColumns = updateData.tableColumns || prev.tableColumns;
        if (updateData.tableColumns && Array.isArray(updateData.tableColumns) && Object.keys(customPropertiesTypes).length > 0) {
          finalTableColumns = updateData.tableColumns.map(column => {
            const columnName = column.metaData?.name;
            const typeFromCustomProperties = customPropertiesTypes[columnName];
            
            // For custom columns, use type from customPropertiesValues if available (most recent from server)
            if (typeFromCustomProperties !== undefined) {
              return {
                ...column,
                type: typeFromCustomProperties
              };
            }
            return column;
          });
        }
        
        const nextSettings = {
          ...prev,
          ...updateData,
          tableColumns: finalTableColumns,
          filtersSchemes: (updateData.filtersSchemes) ? updateData.filtersSchemes : prev.filtersSchemes,
        };
        return {
          ...state,
          templateSettings: nextSettings,
        };
      }
    case CREATE_SETTING_FILTER_SCHEME: {
      const { filtersSchemes } = payload
      return {
        ...state,
        templateSettings: {
          ...state.templateSettings,
          filtersSchemes: filtersSchemes
        }
      }
    }
    case GET_PARAMETERS_OF_SELECTED_ELEMENTS: {
      // is anyone else using customPropertiesValues, commonParameters??
      // const { customPropertiesValues, commonParameters, parametersOfSelection } = payload
      const { parametersOfSelection } = payload

      return {
        ...state,
        parametersOfSelection
      }
    }
    case CLEAR_PARAMETERS_OF_SELECTED_ELEMENTS_FROM_STATE: {
      const newCustomPropertiesValues = state.customPropertiesValues.map(cp => {
        cp.selectedValue = null
        return cp
      })

      return {
        ...state,
        // customPropertiesValues: newCustomPropertiesValues,
        parametersOfSelection: {}
      }
    }
    case SAVE_SELECTION_OF_VIEWER: {
      return {
        ...state,
        adskViewerSelection: payload
      }
    }

    default:
      return state;
  }
};
export default viewerReducer;
